import React from 'react';
import { useTranslations } from 'next-intl';
import { DataTestConfig } from '@headless-workspace/config';
import { GlowClickable, GlowIcon, Icons, PropsWithClassName } from '@headless-workspace/glow-ds';
import { useSearchActionContext } from '../provider';

type CloseMenuProps = PropsWithClassName;

export const CloseMenu = ({ className }: CloseMenuProps) => {
    'use memo';

    const t = useTranslations('Header.search.ariaLabel');
    const { handleClose } = useSearchActionContext();

    return (
        <GlowClickable
            className={className}
            ariaLabel={t('closeCross')}
            onClick={handleClose}
            content={{
                icon: <GlowIcon Icon={Icons.Cross} type={'large'} />,
            }}
            dataTestId={DataTestConfig.testIds.closeSearchPanelButton}
        />
    );
};
